var map = {
	"./consulting/agile-projects.png": "Y3iI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1Je";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/agile\-projects\.png$
// module id = b1Je
// module chunks = 0